<template>
  <div class="market-cooperation">
    <main class="market-cooperation-main">
      <img loading="lazy" class="main-bg" src="@/assets/img/marketCooperation/1.png" alt="">
      <img loading="lazy" class="market-cooperation-main-content" src="@/assets/img/marketCooperation/2.png" alt="">
      <div class="client-list">
        <div class="title">{{ '客户名录' }}</div>
        <el-carousel ref="carousel" class="carousel"
          :style="{ minHeight: cooperationList[0].length <= 5 ? '190px' : '380px' }" trigger="click" :autoplay="false"
          indicator-position="none" :arrow="cooperationList.length > 1 ? 'hover' : 'never'">
          <el-carousel-item v-for="(arr, index) in cooperationList" :key="index">
            <div class="carousel-item">
              <div class="client" v-for="item in arr" :key="item.id" @click="openUrl(item.linkUrl)">
                <img loading="lazy" v-if="item.photo" :src="item.photo" alt="">
                <div class="name">{{ item.name }}</div>
              </div>
            </div>

          </el-carousel-item>
        </el-carousel>
      </div>
    </main>
    <Footer class="footer" />
  </div>
</template>

<script>
import Footer from '@/components/footer/index'
export default {
  name: '',
  components: {
    Footer
  },
  props: [],
  data() {
    return {
      cooperationList: [[]],
    }
  },
  created() {
    this.getCooperationData()
  },
  mounted() {

  },
  methods: {
    // 二维数组
    getCooperationData() {
      this.$apis.cooperation_list().then(res => {
        let count = 0
        let index = 0
        for (let i = 0; i < res.data.length; i++) {
          this.cooperationList[index].push(res.data[i])
          count++
          if (count % 10 == 0 && count != res.data.length) {
            this.cooperationList.push([])
            index++
          }
        }
      })
    },
    openUrl(url) {
      if (url.split('//')[1]) {
        window.open(url, '_blank')
      }

    }
  },
}
</script>

<style lang='scss' scoped>
.market-cooperation {
  display: flex;
  flex-direction: column;
  min-height: 100%;

  .market-cooperation-main {
    flex: 1;
    // padding-bottom: 30px
    display: flex;
    flex-direction: column;


    .market-cooperation-main-content {
      width: 120rem;
      height: 37.5rem;
    }

    .client-list {
      flex: 1;
      background: #F0F9FF;
      text-align: left;
      padding: 1.25rem 0 1.875rem 0;

      .title {
        font-family: FZLanTingHei-H-GBK;
        font-weight: 600;
        font-size: 1.75rem;
        color: #81B1D7;
        font-style: italic;
        height: 2.3125rem;
        margin-left: 15.625rem;
      }

      .carousel {
        width: 100%;
        // min-height: 380px;
        position: relative;
        margin-top: 1.25rem;

        .carousel-item {
          width: 87.5rem;
          position: absolute;
          left: 50%;
          transform: translateX(-50%) !important;
          display: grid;
          grid-template-columns: repeat(5, 1fr);
          // grid-template-rows: repeat(2, 1fr);
          column-gap: 1.875rem;
          row-gap: 1.25rem;

          .client {
            cursor: pointer;
            height: 11.25rem;
            width: 16rem;
            display: grid;
            grid-template-rows: 9.375rem 2.5rem;
            align-items: center;
            // justify-content: center;
            text-align: center;

            img {
              height: 9.375rem;
              width: 16rem;
            }

            .name {
              text-overflow: ellipsis;
              overflow: hidden;
              word-break: break-all;
              white-space: nowrap;
              padding: 0 0.625rem;
            }

            &:hover .name {
              text-decoration: underline;
              color: #3d99e4;
            }
          }

        }

      }

    }

  }
}
</style>

<style>
.market-cooperation {
  .el-carousel__container {
    height: 100% !important;
    position: static !important;
  }

  .el-carousel__arrow--left,
  .el-carousel__arrow--right {
    font-size: 6.75rem;
    font-weight: 600;
    background: transparent;
    color: #647684;

    &>:hover {
      color: #0096FF;
    }

  }

  .el-carousel__arrow--left {
    left: 6.25rem;
    top: 6.25rem;


  }

  .el-carousel__arrow--right {
    right: 6.25rem;
    top: 6.25rem;
  }
}
</style>